<!--
 * @Description: 添加、编辑node弹框组件
 * @Author: fal
 * @FilePath: \pc.ui\src\project\components\tree\optNode.vue
 * @LastEditTime: 2025-06-19 15:06:09
-->
<template>
  <el-dialog :title="title" :visible="visible" width="348px" class="pay-amount-modal" :close-on-click-modal="false" append-to-body @close="handleClose">
    <el-divider></el-divider>
    <el-form ref="form" label-width="113px" style="position: relative; padding: 10px">
      <div v-if="title === '编辑'">
        <el-input placeholder="请输入" v-model="text"></el-input>
      </div>
      <div v-else style="max-height: 400px; overflow-y: auto">
        <div class="mb-10" v-for="(i, index) in texts" :key="index">
          <el-input placeholder="请输入" v-model="i.text">
            <i v-if="index > 0" class="el-icon-close el-input__icon" slot="suffix" @click="handleIconClick(index)"> </i>
          </el-input>
        </div>
        <div style="margin: 10px 0; cursor: pointer; color: #1b70ff" @click="addSon">
          <i class="el-icon-plus" color="#1B70FF"></i>
          添加子项
        </div>
      </div>
    </el-form>
    <el-divider></el-divider>
    <div slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" @click="handleClose">取消</el-button>
      <el-button class="submit-btn" type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'optNode',
  props: ['visible', 'title', 'node'],
  data() {
    return {
      text: '',
      texts: [{ text: '' }],
      handleSubmitFn: this.$throttle(this.handleSubmit),
    };
  },
  watch: {
    node(newVal) {
      this.texts = [{ text: '' }];
      this.text = newVal;
      if (this.title != '编辑') {
        this.texts = [{ text: '' }];
      }
    },
  },
  methods: {
    addSon() {
      this.texts.push({ text: '' });
    },
    handleClose() {
      this.text = '';
      this.texts = [{ text: '' }];
      this.$emit('cancel');
    },
    handleIconClick(index) {
      this.texts.splice(index, 1);
    },
    handleSubmit() {
      console.log(this.texts);
      console.log(this.text);
      console.log(this.title);
      const arr = this.texts.map((item) => item.text).filter((itm) => itm != '' && itm != null && itm != undefined);
      console.log(arr);

      if (this.title == '编辑' && this.text.trim()) {
        this.$emit('submit', this.text);
        // this.handleClose();
      } else if (this.title != '编辑' && arr.length) {
        this.$emit('submit', arr);
        // this.handleClose();
      } else {
        this.$message.error('请填写');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pay-amount-modal {
  :deep(.el-dialog) {
    border-radius: 8px;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 800;
      line-height: 24px;
      color: #333;
    }
    .el-dialog__body {
      padding: 0 20px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
  }

  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0;
  }

  .unit {
    display: inline-block;
    line-height: 37px;
    min-width: 37px;
    text-align: center;
    box-sizing: border-box;
    line-height: 37px;
    position: absolute;
    right: 20px;
    top: 10px;
    color: rgba(153, 153, 153, 0.6);
  }

  .dialog-footer {
    margin-right: 20px;
    text-align: right;
    .cancel-btn,
    .submit-btn {
      background-color: #1b70ff;
      width: 112px;
      height: 44px;
      border-radius: 4px;
      font-size: 20px;
      color: #fff;
    }
    .cancel-btn {
      background-color: #fff;
      border: 1px solid #999999;
      color: #999999;
    }
  }
}
</style>
